import script from "./UiRemovableFileItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiRemovableFileItem.vue?vue&type=script&setup=true&lang=ts"

import "./UiRemovableFileItem.vue?vue&type=style&index=0&id=57b686c8&lang=sass"

const __exports__ = script;

export default __exports__